import { Component, OnInit, OnDestroy, Inject, Optional, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { PershingTranslationService } from '@pershing/pershing-core';
import { NxiNavigation, PortalNavigationService } from '@pershing/nxi-ng-common';
import { ActivatedRoute } from '@angular/router';
@Component({
    selector: 'modern-theme-secondlevel-navigation',
    templateUrl: 'modern-theme-secondlevel-navigation.component.html',
    styleUrls: ['./modern-theme-secondlevel-navigation.component.css']
})

export class ModernThemeSecondLevelNavigationComponent implements OnDestroy, OnInit {
    secondNavLinks: any[];
    selectedPageId: string;
    selectedPage: any;
    navigation: NxiNavigation;
    showSecondNav: boolean;
    titleValueArray: string[];
    titleValue: string;
    isSSO: boolean = false;
    parentNavSub: any;
    childNavSub: any;
    @ViewChildren('navLink') navLinks: QueryList<ElementRef>;

    constructor(private translationService: PershingTranslationService, 
        private navigationService: PortalNavigationService, 
        private route: ActivatedRoute, 
        @Optional() @Inject('AppSettings') appSettings: any) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-modern-navigation', 'node_modules/@pershing/nxi-ng-modern-navigation/lib');
        this.isSSO = this.handleSSO(appSettings);
        this.handleParentPageSubscription();
        this.handleChildPageSub();
    }



    handleKeyDown(event: KeyboardEvent, index: number) {
        if (event.key === 'ArrowRight') {
            // Focus on the next element
            if (index < this.secondNavLinks.length - 1) {
                this.navLinks.toArray()[index + 1].nativeElement.focus();
            }
        } else if (event.key === 'ArrowLeft') {
            // Focus on the previous element
            if (index > 0) {
                this.navLinks.toArray()[index - 1].nativeElement.focus();
            }
        } else if (event.key === ' ') {
            // Handle the space key
            this.handleChildNavigation(this.secondNavLinks[index]);
        }
    }

    handleSSO(appSettings: any): boolean {
        return appSettings?.isVendorSso || appSettings?.isAdvisor;
    }
    handleParentPageSubscription() {
        this.parentNavSub = this.navigationService.getParentPage().subscribe(data => {
            if (data && data.children && data.children.length > 0) {
                // To remove financial planning from menu when theme switch or page refresh happens
                if (data.id === 'tools') {
                    data = this.handleRemoveMenu(data);
                }
                if (data.id === 'settings') {
                    data = this.handleSecuritySettingsForSSO(data);
                }
                if (data.children.length > 0) {
                    this.showSecondNav = true;
                    if (data.id !== 'postlogin-security') {
                        // Do not override the navlinks. Since postlogin-security doesnt has a proper menu.
                        // If the list gets added move to constant file.
                        this.secondNavLinks = data.children.filter(link => !link.hideFromNavigation);
                    }
                } else {
                    this.showSecondNav = false;
                }
            } else {
                this.showSecondNav = false;
            }
        });
    }
    handleChildPageSub() {
        this.childNavSub = this.navigationService.getChildPage().subscribe(childpage => {
            if (childpage) {
                this.selectedPageId = childpage.id;
            }
        });
    }
    handleChildNavigation(childPage): void {
        this.navigation = new NxiNavigation();
        // this.selectedPageId = childPage.id;
        // this.navigation.parentPage = this.selectedPage;
        this.navigation.childPage = childPage;
        this.navigationService.handleNavigation(this.navigation);
    }
    handleRemoveMenu(data: any) {
        if (data.children.length > 0) {
            let finPlanID = 'financialplanning';
            if (data.children.filter(item => finPlanID === item.id).length > 0
                && !!sessionStorage.getItem('rmvFinPlan') && sessionStorage.getItem('rmvFinPlan') === 'Y') {
                data.children = data.children.filter(item => !finPlanID.includes(item.id));
                return data;
            }
        }
        return data;
    }
    handleSecuritySettingsForSSO(data: any) {
        if (data.children.length > 0) {
            let securitySettings = 'securitysettings';

            if (data.children.filter(item => securitySettings === item.id).length > 0 
                && this.isSSO) {
                data.children = data.children.filter(item => !securitySettings.includes(item.id));
                return data;
            }
        }
        return data;
    }
    ngOnInit() {
        console.log(' In Component OnInit ');
    }
    public ngOnDestroy() {
        this.parentNavSub?.unsubscribe();
        this.childNavSub?.unsubscribe();
    }
    

}
